import React from 'react';

import { useInView } from 'react-intersection-observer';
import CircularProgress from '@mui/material/CircularProgress';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';

import { getFileKey } from '../../../../actions/server';

/**
 * Component that displays an image from the file giving in parameters
 * During the loading it display a circula progress
 * If an error occurs displays a broken file icon
 * It only starts the download when the image is in the viewport
 * 
 * @param {*} file: the file to display
 * @param {*} thumbSize: the max size of the thumbnail 
 * @param {*} downloadThumb: function that download the thumbnail
 *  
 */
function ImageComponent({ file, thumbSize, downloadThumb }) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.5 });
  const [thumb, setThumb] = React.useState(null);
  const [error, setError] = React.useState(false);

  async function donwloadOneFile(file) {
    var fileKey = getFileKey(file);
    if (!thumb) {
      await downloadThumb(fileKey).then(response => {
        var reader = new FileReader();
        reader.onloadend = function (e) {
          setThumb(e.target.result);
        }
        reader.readAsDataURL(response.data);
      }).catch(() => {
        setError(true);
      })
    }
  }

  React.useEffect(() => {
    if (inView && !thumb) {
      donwloadOneFile(file);
    }
  }, [inView, file]);

  return (
    <div ref={ref} style={{ 
      height: thumbSize, 
      width: thumbSize,
      display: "flex", 
      alignItems: "center",
			justifyContent: "center"
    }} >
      {error ?  (
        <BrokenImageIcon  sx={{
          width: thumbSize,
          height: thumbSize,
          opacity: 0.2
        }} />
        ) : ( thumb ? (
            <img src={thumb} style={{
              maxWidth: thumbSize,
              maxHeight: thumbSize
            }}/>
            ) : (
              <CircularProgress size={thumbSize} />
            )
        )
      }
    </div>
  );
}

export default ImageComponent;